import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { Button } from '../ui/Button';
import { Dialog, DialogBody, DialogContent, DialogHeader, DialogTitle } from '../ui/Dialog';
import { useAuth } from '../../contexts/AuthContext';

export function UserSettingsDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const { user, updateTheme, updatePreferences } = useAuth();
  const [saving, setSaving] = useState(false);

  if (!user) return null;

  const teamsInboxEnabled = (user as any)?.preferences?.notifications?.teams_inbox !== false;

  const setTeamsInboxEnabled = async (enabled: boolean) => {
    setSaving(true);
    try {
      await updatePreferences({
        notifications: {
          ...(user as any)?.preferences?.notifications,
          teams_inbox: enabled,
        },
      } as any);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent maxWidth="3xl">
        <DialogHeader>
          <DialogTitle>User Settings</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="space-y-4">
            <Card>
              <CardHeader>
                <CardTitle>Appearance</CardTitle>
              </CardHeader>
              <CardContent className="flex gap-2">
                <Button
                  variant={user.preferences.theme === 'dark' ? 'default' : 'outline'}
                  onClick={() => updateTheme('dark')}
                >
                  Dark
                </Button>
                <Button
                  variant={user.preferences.theme === 'light' ? 'default' : 'outline'}
                  onClick={() => updateTheme('light')}
                >
                  Light
                </Button>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Notifications</CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <div className="flex items-start justify-between gap-4">
                  <div className="space-y-1">
                    <div className="text-sm font-medium leading-none">
                      Teams inbox (header bell)
                    </div>
                    <div className="text-xs text-gray-600 dark:text-gray-400">
                      Shows the Teams notifications bell and allows polling Teams chat notifications (requires Graph API access for your organization).
                    </div>
                  </div>
                  <Button
                    variant={teamsInboxEnabled ? 'default' : 'outline'}
                    disabled={saving}
                    onClick={() => setTeamsInboxEnabled(!teamsInboxEnabled)}
                  >
                    {teamsInboxEnabled ? 'Enabled' : 'Disabled'}
                  </Button>
                </div>
              </CardContent>
            </Card>
          </div>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}

